const customIcons = Array(

    // Test 2 Icon
    {
      prefix: 'ncr',
      iconName: 'test1',
      icon: [
        448, 448,
        [],
        null,
        'M163.006,417.598  L163.006,31.402 L224.5,122.983 L285.995,31.402 L282.985,142.371 L385.495,105.159 L319.13,193.13 L423.5,224.5 L319.13,255.871 L385.494,343.841 L282.984,306.629 L285.994,417.598 L224.5,326.017 z'
      ]
    },
    // Template Icon
    // {
    //   prefix: 'ncr',
    //   iconName: '{{ name of icon }}',
    //   icon: [
    //     448, 448,
    //     [],
    //     null,
    //     '{{ Replace this with SVG CODE }}'
    //   ]
    // },
    
  )